var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement } from "react";
import classNames from "classnames";
import GridColumn from "./GridColumn";
// styles
import "./grid.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-grid",
    itemsAlign: "center",
};
const Grid = (_a) => {
    var { gutter, itemsAlign, children, className } = _a, rest = __rest(_a, ["gutter", "itemsAlign", "children", "className"]);
    const classList = classNames("tecma-grid", { [`${itemsAlign}`]: itemsAlign }, className);
    const columnStyle = gutter
        ? { paddingLeft: `${gutter / 2}px`, paddingRight: `${gutter / 2}px` }
        : "";
    return (_jsx("div", Object.assign({ className: classList }, rest, { children: Children.map(children, (child) => cloneElement(child, { style: Object.assign({}, columnStyle) })) })));
};
Grid.defaultProps = defaultProps;
const GridSpace = Object.assign(Grid, {
    Column: GridColumn,
});
export { GridSpace as Grid };
